module.exports = __webpack_public_path__ + "static/media/divulgador_logo.2bdf3e1f.svg";